var _rect, _rect2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Greetingcards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    rx: 80,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 159,
    height: 159,
    rx: 79.5,
    stroke: "#364957",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.5854 67.4492H68.3112C66.8696 67.4492 65.7009 68.6179 65.7009 70.0595V89.2014C65.7009 90.643 66.8696 91.8117 68.3112 91.8117H90.5854C92.0269 91.8117 93.1957 90.643 93.1957 89.2014V70.0595C93.1957 68.6178 92.0269 67.4492 90.5854 67.4492ZM87.9751 86.4171H70.9214V72.6696H87.9751V86.4171Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3376 101.382H68.2373C66.7958 101.382 65.6271 102.551 65.6271 103.993C65.6271 105.434 66.7958 106.603 68.2373 106.603H90.3376C91.7792 106.603 92.9479 105.434 92.9479 103.993C92.9479 102.551 91.7794 101.382 90.3376 101.382Z",
    fill: "#6B7280"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2125 58.0521H93.1956V46.6105C93.1956 45.725 92.7098 44.8999 91.9664 44.4187C91.2228 43.9378 90.2683 43.8662 89.4601 44.2296L58.5126 58.151C57.5753 58.5723 57 59.5042 57 60.5319V113.259C57 114.701 58.0949 116 59.5364 116H99.2124C100.654 116 101.897 114.701 101.897 113.259V60.5319C101.897 59.0905 100.654 58.0521 99.2125 58.0521ZM87.9751 50.6454V58.0521H71.7119L87.9751 50.6454ZM96.6761 110.779H62.2205V63.2727H96.6761V110.779Z",
    fill: "#6B7280"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Greetingcards);
export default __webpack_public_path__ + "static/media/4greetingcards.099ca8f30ea201b1f3f067d7baa846b9.svg";
export { ForwardRef as ReactComponent };